import React, {useState, useEffect} from 'react'
import Dropdown from '../../../../Assets/Dropdown'
import Input from '../../../../Assets/Input'

// utils
import { handleNumberInput } from '../../../../../utils/formUtils';

const OddsRange = (props) => {
    const [rangeType, setRangeType] = useState("");
    const [min, setMin] = useState(null);
    const [max, setMax] = useState(null);
    const [critVal, setCritVal] = useState({
        type: "line.odds-filter",
        rangeType: ""
    });
    const [initCrit, setInitCrit] = useState(null);
    const [critIdx, setCritIdx] = useState(null);
    const [errs, setErrs] = useState([]);
    const [errMsg, setErrMsg] = useState(null);

    const filterOptions = [
        { value: "between", label: "Odds are between" },
        { value: "greater", label: "Odds are greater than" },
        { value: "less", label: "Odds are less than" }
    ];

    const formFields = {
        min: (
            <div className="relative">
                <Input
                    id="min"
                    type="number"
                    value={min || ''}
                    onChange={(e) => handleNumberInput(e.target.value, setMin)}
                    className={errs.includes('min') ? 'ring-2 ring-brand-red-500 border-brand-red-500' : ''}
                    placeholder=" "
                    aria-label="Minimum Odds (American)"
                />
                <label
                    htmlFor="min"
                    className={`absolute -top-2 left-2 inline-block bg-white dark:bg-gray-900 px-1 text-xs font-medium ${
                        errs.includes('min') ? 'text-brand-red-500' : 'text-gray-900 dark:text-gray-400'
                    }`}
                >
                    Minimum Odds (American)
                </label>
            </div>
        ),
        max: (
            <div className="relative">
                <Input
                    id="max"
                    type="number"
                    value={max || ''}
                    onChange={(e) => handleNumberInput(e.target.value, setMax)}
                    className={errs.includes('max') ? 'ring-2 ring-brand-red-500 border-brand-red-500' : ''}
                    placeholder=" "
                    aria-label="Maximum Odds (American)"
                />
                <label
                    htmlFor="max"
                    className={`absolute -top-2 left-2 inline-block bg-white dark:bg-gray-900 px-1 text-xs font-medium ${
                        errs.includes('max') ? 'text-brand-red-500' : 'text-gray-900 dark:text-gray-400'
                    }`}
                >
                    Maximum Odds (American)
                </label>
            </div>
        )
    };

    const forms = {
        "between": (
            <div className="space-y-4">
                {formFields.min}
                {formFields.max}
            </div>
        ),
        "greater": formFields.min,
        "less": formFields.max    
    };

    // run when init crit changes
    useEffect(()=> {
        // check if user is editing an existing criteria
        if(props.initCrit){
            const critCopy = {...props.initCrit.crit};
            setCritVal(critCopy);
            setRangeType(critCopy.rangeType);
            setInitCrit(critCopy);
            setCritIdx(props.initCrit.index);
            switch(critCopy.rangeType){
                case "between":
                    setMin(critCopy.min.toString());
                    setMax(critCopy.max.toString());
                    break;
                case "greater":
                    setMin(critCopy.min.toString());
                    break;
                case "less":
                    setMax(critCopy.max.toString());
                    break;
                default: 
                    break;
            };
        };
    },[props.initCrit])

    // function to check if init criteria has changed
    const checkCritChange = () => {
        let modified = false;
        if(critIdx  != null){
            if(critVal.rangeType !== initCrit.rangeType){
                modified = true;
            };
            switch(critVal.rangeType){
                case "between":
                    if(critVal.min !== initCrit.min || critVal.max !== initCrit.max){
                        modified = true;
                    };
                    break;
                case "greater":
                    if(critVal.min !== initCrit.min){
                        modified = true;
                    };
                    break;
                case "less":
                    if(critVal.max !== initCrit.max){
                        modified = true;
                    };
                    break;
            };
        }else{
            modified = true;
        };
        return modified;
    };

    // function to check for errors
    const checkErrs = () => {
        let tmpErrs = [];
        let tmpErrMsg = null;
        switch(critVal.rangeType){
            case "between":
                if(min === "" || isNaN(parseFloat(min, 10))){
                    tmpErrs.push("min");
                };
                if(max === "" || isNaN(parseFloat(max, 10))){
                    tmpErrs.push("max");
                };
                if(min !== "" && max !== "" && !isNaN(min) && !isNaN(max)){
                    if(parseFloat(min, 10) >= parseFloat(max, 10)){
                        tmpErrs.push("min");
                        tmpErrs.push("max");
                        tmpErrMsg = "Please ensure the minimum odds value is less than the maximum";
                    };
                };
                break;
            case "greater":
                if(min === "" || isNaN(parseFloat(min, 10))){
                    tmpErrs.push("min");
                };
                break;
            case "less":
                if(max === "" || isNaN(parseFloat(max, 10))){
                    tmpErrs.push("max");
                };
                break;
            default:
                tmpErrs.push("odds-type");
                break; 
        };
        return({errs: tmpErrs, msg: tmpErrMsg});
    };

    // set submit function in parent component
    const validateSubmit = (e) => {
        e.preventDefault();
        // check for errors
        const errCheck = checkErrs(); 
        setErrMsg(errCheck.msg);
        setErrs(errCheck.errs);
        if(errCheck.errs.length === 0){
            // check for crit change - returns true if initCrit was modified or not passed
            const modified = checkCritChange();
            if(modified){
                props.sysContext.changeCrit(critVal, critIdx);
                props.sysContext.setCritDisp(null);
            };
            props.sysContext.setStep(2);
        };
    };

    useEffect(()=>{
        let tmpCrit = {
            type: "line.odds-filter",
            rangeType: rangeType,
        };
        const minNum = min === "" ? null : parseFloat(min, 10);
        const maxNum = max === "" ? null : parseFloat(max, 10);
        const minLbl = minNum === null ? "" : (minNum > 0 ? `+${minNum}` : `${minNum}`);
        const maxLbl = maxNum === null ? "" : (maxNum > 0 ? `+${maxNum}` : `${maxNum}`);
        
        switch(rangeType){
            case "between": 
                tmpCrit.min = minNum;
                tmpCrit.max = maxNum;
                tmpCrit.label = `Odds are between ${minLbl} and ${maxLbl}`;
                break;
            case "greater":
                tmpCrit.min = minNum;
                tmpCrit.label = `Odds are ${minLbl} or greater`;
                break;
            case "less":
                tmpCrit.max = maxNum;
                tmpCrit.label = `Odds are ${maxLbl} or less`;
                break;
            default:
                break;
        };

        setCritVal(tmpCrit);
    }, [rangeType, min, max]);

    // run whenever errs changes
    useEffect(()=>{
        // get all elements previously in error state and remove class
        let prevErrs = document.getElementsByClassName("err");
        while(prevErrs.length){
            prevErrs[0].classList.remove("err");
        };
        // add err class based on updated errs
        errs.forEach(err=>{
            const elem = document.getElementById(err);
            if(elem){
                elem.classList.add("err");
            };
        });
    },[errs]);

    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-5">
                <h2 className="text-xl font-semibold leading-6 text-gray-900 dark:text-white">
                    Odds Filter
                </h2>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Set your odds range criteria for filtering bets.
                </p>
            </div>

            <form className="space-y-6">
                <div>
                    <Dropdown
                        id="odds-type"
                        title="Select a filter type"
                        items={filterOptions}
                        onSelect={(value) => setRangeType(value)}
                        activeItem={rangeType}
                        className={errs.includes('odds-type') ? 'ring-2 ring-brand-red-500' : ''}
                    />
                    {errs.includes('odds-type') && (
                        <p className="mt-2 text-sm text-brand-red-500 dark:text-brand-red-400">
                            Please select a filter type
                        </p>
                    )}
                </div>

                {rangeType !== "" && (
                    <div className="mt-4">
                        {forms[rangeType]}
                    </div>
                )}

                {errMsg && (
                    <p className="mt-2 text-sm text-brand-red-500 dark:text-brand-red-400">
                        {errMsg}
                    </p>
                )}

                <div className="flex items-center justify-end gap-3">
                    <button
                        type="button"
                        onClick={() => props.cancel()}
                        className="rounded-md bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={(e) => validateSubmit(e)}
                        className="rounded-md bg-brand-red-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red-500"
                    >
                        Save Criteria
                    </button>
                </div>
            </form>
        </div>
    );
};

export default OddsRange;